import {getUsersError} from "./usersActions";

export const getSensorsPending = () => {
    return {
        type: 'GET_SENSORS_PENDING'
    }
};

export const getSensorsSuccess = (sensors, page, pageCount, itemsCount, sensorTypes, antennas) => {
    return {
        type: 'GET_SENSORS_SUCCESS',
        sensors,
        page,
        pageCount,
        itemsCount,
        sensorTypes,
        antennas
    }
};

export const getSensorsDetailsPending = () => {
    return {
        type: 'GET_SENSORS_DETAILS_PENDING'
    }
};

export const getSensorsDetailsSuccess = () => {
    return {
        type: 'GET_SENSORS_DETAILS_SUCCESS'
    }
};

export const getSensorsCalibrationDetailsPending = () => {
    return {
        type: 'GET_SENSORS_CALIBRATION_DETAILS_PENDING'
    }
};

export const getSensorsCalibrationDetailsSuccess = () => {
    return {
        type: 'GET_SENSORS_CALIBRATION_DETAILS_SUCCESS'
    }
};


export const getSensorsError = error => {
    return {
        type: 'GET_SENSORS_ERROR',
        error: error
    }
};

export const getSensorsUpdateTimesSuccess = times => {
    return {
        type: 'GET_SENSOR_UPDATE_TIMES',
        updateTimes: times
    }
}

export const getSensorUpdateTypesSuccess = types => {
    return {
        type: 'GET_SENSOR_UPDATE_TYPES',
        sensorUpdateTypes: types
    }
}

export const getSensorAlertRulesSuccess = rules => {
    return {
        type: 'GET_SENSOR_ALERT_RULES',
        sensorAlertRules: rules
    }
}

export const getSensorCalibrationValuesSuccess = calibrationValues => {
    return {
        type: 'GET_SENSOR_CALIBRATION_VALUES',
        sensorCalibrationValues: calibrationValues
    }
}

export const getSoilTypes = () => async dispatch => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/get_soil_types`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        }
    });
    if (!response.ok) {
        const error = `Error: ${response.status} ${response.statusText}`;
        dispatch(getSensorsError(error));
        throw new Error(error);
    }
    return response.json();
};

export const updateSensorSoilType = (sensorId, userId, soilType) => async dispatch => {
    const body = {id: sensorId, soilType};
    if (userId) body.userId = userId;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/update_sensor_soil_type`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        },
        body: JSON.stringify(body)
    });
    if (!response.ok) {
        const error = `Error: ${response.status} ${response.statusText}`;
        dispatch(getSensorsError(error));
        throw new Error(error);
    }
    return response.json();
};

export const removeSensorSoilType = (sensorId, userId) => async dispatch => {
    const userIdParameter = userId ? `&userId=${encodeURIComponent(userId)}` : '';
    const response = await fetch(`${process.env.REACT_APP_API_URL}/remove_soil_type_from_sensor?sensorId=${encodeURIComponent(sensorId)}${userIdParameter}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': sessionStorage.getItem('agronetToken'),
            'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
        }
    });
    if (!response.ok) {
        const error = `Error: ${response.status} ${response.statusText}`;
        dispatch(getSensorsError(error));
        throw new Error(error);
    }
    return response.json();
};

export const getSensorAlertRulesOptionSuccess = rules => {
    return {
        type: 'GET_SENSOR_ALERT_RULES_OPTIONS',
        sensorAlertRulesOptions: rules
    }
}


export const updateSensorsMeasurementTime = (status) => {
    return {
        type: 'SET_SENSOR_UPDATE_TIME_STATUS',
        updateTimeStatus: status
    }
}

export const getTemperatureConfigListForSensorSuccess = configs => {
    return {
        type: 'GET_SENSOR_TEMPERATURE_CONFIG_LIST',
        sensorTemperatureConfigs: configs
    }
}

export const getTemperatureConfigListOptionsForSensorSuccess = configs => {
    return {
        type: 'GET_SENSOR_TEMPERATURE_CONFIG_LIST_OPTIONS',
        sensorTemperatureConfigsOptions: configs
    }
}

export const getColdTemperatureConfigListForSensorSuccess = configs => {
    return {
        type: 'GET_COLD_SENSOR_TEMPERATURE_CONFIG_LIST',
        sensorColdTemperatureConfigs: configs
    }
}

export const getColdTemperatureConfigListOptionsForSensorSuccess = configs => {
    return {
        type: 'GET_COLD_SENSOR_TEMPERATURE_CONFIG_LIST_OPTIONS',
        sensorColdTemperatureConfigsOptions: configs
    }
}

export const getSensors = (page, numberPerPage, filter, userId, search, lat, lon, sensorType) => {
    return dispatch => {
        dispatch(getSensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/filtered_sensor_list`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                userId: userId ? userId : 0,
                sensorsFilter: filter ? filter : 'ALL',
                page: page ? page : 1,
                numberOnPage: numberPerPage ? numberPerPage : 3,
                lat: lat ? lat : null,
                lon: lon ? lon : null,
                searchQuery: search ? search : '',
                sensorType: sensorType ? sensorType : ''
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsSuccess(res.sensors, res.page, res.pageCount, res.itemsCount, res.sensorTypes, res.antennas))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectSensor = (sensor, page) => {
    return {
        type: 'SELECT_SENSOR',
        selected: { sensor: sensor, page }
    };
};

export const deleteSensor = (id, page, numberPerPage, filter, userId) => {
    return dispatch => {
        dispatch(getSensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/delete_sensor/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getSensors(page, numberPerPage, filter, userId));
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const resetSensor = (id) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/panel/sensor_reset_ttn/${id}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    // dispatch(getSensors(page, numberPerPage, filter, userId));
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}

export const updateLoraIdentifier = (sensorId, loraIdentifier) => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/panel/update_sensor_lora_identifier/${sensorId}/${loraIdentifier}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorDetailsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const updateSensorDetails = (payload) => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/update_sensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorDetailsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
export const updateSensorMeasurementTime = (sensorId, uploadTime) => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/panel/update_sensor_measurement_upload_time/${sensorId}/${uploadTime}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                   console.log('success')
                } else {
                    dispatch(getSensorDetailsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(() => {
                dispatch(updateSensorsMeasurementTime('Success'))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const updateAllSensorsMeasurementTypes = (nodeTypeName, uploadTime) => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/panel/update_all_sensors_measurement_upload_time/${nodeTypeName}/${uploadTime}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    console.log('success')
                } else {
                    dispatch(getSensorDetailsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            // .then(() => {
            //     dispatch(updateSensorsMeasurementTime('Success'))
            // })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveSensorType = (id, nodeTypeId, page, numberPerPage, filter, userId) => {
    return dispatch => {
        dispatch(getSensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_sensor_type`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({id, nodeTypeId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getSensors(page, numberPerPage, filter, userId));
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const setSensorsFilters = filters => {
    return {
        type: 'SET_SENSORS_FILTERS',
        filters: filters
    }
};

export const getSensorDetailsPending = () => {
    return {
        type: 'GET_SENSOR_DETAILS_PENDING'
    }
};

export const getSensorDetailsSuccess = details => {
    return {
        type: 'GET_SENSOR_DETAILS_SUCCESS',
        details
    }
};

export const getSensorDetailsError = error => {
    return {
        type: 'GET_SENSOR_DETAILS_ERROR',
        error: error
    }
};

export const getSensorDetails = sensorId => {

    return dispatch => {
        dispatch(getSensorDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor_details?sensorId=${sensorId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorDetailsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorDetailsSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getSensorsByType = (sensorType, userId) => {

    return dispatch => {
        dispatch(getSensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/filtered_sensor_list`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                userId: userId ? userId : 0,
                sensorType: sensorType ? sensorType : ''
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsSuccess(res.sensors, res.page, res.pageCount, res.itemsCount, res.sensorTypes, res.antennas))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getGateSwitcherSensors = (sensorType, userId) => {

    return dispatch => {
        dispatch(getSensorsPending());

        const url = sensorType === 'TEMPERATURE_SENSOR' ? 'sensor_list_for_gate_control' : 'switcher_list_for_gate_control'

        fetch(`${process.env.REACT_APP_API_URL}/panel/${url}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                userId: userId ? userId : 0,
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsSuccess(res.sensors, res.page, res.pageCount, res.itemsCount, res.sensorTypes, res.antennas))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getSensorsUpdateTimes = () => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/sensor_measurement_upload_times`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsUpdateTimesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getSensorTypesForTimeUpdate = () => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/sensor_types_for_time_update`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorUpdateTypesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getWarmTemperatureConfigListForSensor = (sensorId) => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/sensor/getWarmConfigList?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getTemperatureConfigListForSensorSuccess(res))
                dispatch(getSensorsDetailsSuccess())
                dispatch(getTemperatureConfigListOptionsForSensorSuccess(res.map(el => ({...el, label: el?.configName, value: el?.configName }))))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getColdTemperatureConfigListForSensor = (sensorId) => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/sensor/getColdConfigList?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getColdTemperatureConfigListForSensorSuccess(res))
                dispatch(getSensorsDetailsSuccess())
                dispatch(getColdTemperatureConfigListOptionsForSensorSuccess(res.map(el => ({...el, label: el?.configName, value: el?.configName }))))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveWarmTemperatureConfig = (sensorId, configId) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/addWarmConfigToSensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId, configId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWarmTemperatureConfigListForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const detachWarmTemperatureConfig = (sensorId) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/removeWarmConfigFromSensor`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getWarmTemperatureConfigListForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveVapourPressure = (obj) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_sensor_vapour_pressure`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                id: obj.sensorId,
                vapourPressure: obj.vapourPressure
            })
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getSensorsDetailsSuccess());
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveColdTemperatureConfig = (sensorId, configId) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/addColdConfigToSensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId, configId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getColdTemperatureConfigListForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const detachColdTemperatureConfig = (sensorId) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/removeColdConfigFromSensor`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getColdTemperatureConfigListForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getAlertRulesForSensor = (sensorId) => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/alert_rules_list_for_sensor?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorAlertRulesSuccess(res))
                dispatch(getSensorsDetailsSuccess())
                dispatch(getSensorAlertRulesOptionSuccess(res.map(el => ({...el, label: el?.ruleName + ' ' +  el.measurementType, value: el.ruleName }))))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveSensorAlertRule = (sensorId, ruleID, ruleName) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/connect_alert_rule_to_sensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId, ruleID, ruleName})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getAlertRulesForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const detachSensorAlertRule = (sensorId, ruleID) => {
    return dispatch => {
        dispatch(getSensorsDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/delete_sensor_alert_rule?sensorId=${sensorId}&ruleId=${ruleID}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getAlertRulesForSensor(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getSensorCalibrationValues = (sensorId) => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/calibration/getCalibrationValueSetsForSensor?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getSensorsCalibrationDetailsSuccess())
                dispatch(getSensorCalibrationValuesSuccess(res.map(el => ({...el, label: el?.setName + ' ' +  el.measurementType, value: el.setName }))))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const saveSensorCalibrationValue = (sensorId, setId) => {
    return dispatch => {
        dispatch(getSensorsCalibrationDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/connectCalibrationValueSetToSensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({sensorId, setId})
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getSensorCalibrationValues(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsCalibrationDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const detachSensorCalibrationValue = (sensorId, setId) => {
    return dispatch => {
        dispatch(getSensorsCalibrationDetailsPending());

        fetch(`${process.env.REACT_APP_API_URL}/calibration/disconnectCalibrationValueSetFromSensor?sensorId=${sensorId}&setId=${setId}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getSensorCalibrationValues(sensorId))
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`))
                    dispatch(getSensorsCalibrationDetailsSuccess())
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getSensorStabilityReport = (sensorId) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/measurements/sensor_stability?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`));
                    return { error: true };
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};

export const updateMeasurementsRequest = (sensorId) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/load_last_sensor_measurements_from_lora?sensorId=${sensorId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getUsersError(`Error: ${res.status} ${res.statusText}`));
                    return { error: true };
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};

export const getSensorGatewayStats = (sensorIdentifier) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/gateways/sensorGatewaysStats?sensorIdentifier=${encodeURIComponent(sensorIdentifier)}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                }
                dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`));
                return { error: true };
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};

export const getNearestRainSensors = (sensorId) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/panel/rain_sensor_corrections/nearest_sensors?sensorId=${sensorId}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`));
                    return { error: true };
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};

export const updateRainSensorCounts = (payload) => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/panel/rain_sensor_corrections`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(getSensorsError(`Error: ${res.status} ${res.statusText}`));
                    return { error: true };
                }
            })
            .catch(err => {
                console.log('ERROR', err);
                return { error: true };
            });
    };
};
